export const PageNotFound = () => {
  return <div>Page not found</div>
}
